<template>
  <div class="qna-form">
    <!-- qna-person-info -->
    <div class="qna-sender-wrapper" :class="{'hide-on-mobile': !isFormExpanded}"  v-if="!this.webcast.qnaAnonymous">
      <div class="qna-sender-info">
        <Avatar icon="ios-person" size="small" style="margin-right:8px;" />
        <span class="qna-sender-name">{{ senderInfo.name }}</span>
        <span class="qna-sender-location"> {{ senderInfo.location }}</span>
      </div>
      <Button type="text" @click="switchToSenderEdit(true)" class="qna-sender-change">{{ $t("change") }}</Button>
    </div>

    <div class="new-question">
      <Input
        v-model="newQuestion"
        type="textarea"
        :rows="newQuestionRows"
        :placeholder="$t('please_write_your_question')"
        @on-focus="toggleQuestionField('focus')"

        class="new-question-field" />
      <Button type="primary" v-if="isFormExpanded" class="new-question--submit" @click="createNewQuestion">{{ $t("send") }}</Button>
      <Button type="default" v-if="isFormExpanded" class="new-question--submit" @click="clearQuestionInput()">{{ $t("cancel") }}</Button>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'
import logger from '@/api/logger'
export default {
  data(){
    return{
      newQuestion: '',
      newQuestionRows: 1,
      isFormExpanded: false
    }
  },
  props: ['senderInfo'],
  computed:{
    ...mapGetters('webcast', {
      webcast: 'getCopy',
    })
  },
  methods:{
    ...mapActions('qna', {
      questionList: 'find',
      createQuestionAction: 'create',
      patchQuestionAction: 'patch'
    }),
    switchToSenderEdit (isEdit) {
      this.$emit('switchToSenderEditEvent', isEdit);
    },
    toggleQuestionField (state) {
      if(state=='focus'){
        this.$set(this.$data, 'newQuestionRows', 3);
        this.isFormExpanded = true;
      } else{
        this.$set(this.$data, 'newQuestionRows', 1);
        this.isFormExpanded = false	;
      }
    },
    clearQuestionInput(){
      this.toggleQuestionField('blur');
      this.newQuestion = '';
    },
    createNewQuestion () {
      let data = {
        webcastId: this.webcast._id,
        name: this.senderInfo.name,
        location: this.senderInfo.location,
        text: this.newQuestion,
        bucket: 'inbox',
        isAnswered: false,
        isApproved: !this.webcast.qnaModeration
      }

      if (data.text) {
        this.createQuestionAction(data).finally(() => {
          this.$Message.success('Your question has been sent');
          this.clearQuestionInput();
        }).catch((err)=>{
          logger.error(err);
          console.log(err);
          this.$Message.success('Error sending question!');
        })
      }
    }
  },
  created(){
  }
}
</script>

<style lang="scss" scoped>
.qna-sender-wrapper{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  &.hide-on-mobile{
    @media screen and (max-width: 992px) {
      display:none;
    }
  }
}
.qna-sender{
  &-name{
    font-size: 14px;
    font-weight: normal;
    color: #367DB8;
  }
  &-location{
    font-size: 14px;
    font-weight: normal;
    color: #808695;
  }
}
.new-question {
  width: 100%;

  &--submit {
    margin-top:16px;
    margin-right:8px;
    float: right;
  }
}
</style>
